import React from 'react';
import { HStack, Text, Image } from '@gluestack-ui/themed';
import { useTenantSettingsStore } from '../../../context/TenantSettingsStore';

/**
 * Header component for the left side of the Lecturer navigation bar.
 * Displays the tenant logo and the 'Lecturer' label.
 */
const LecturerHeaderLeft: React.FC = () => {
  const settings = useTenantSettingsStore((state) => state.settings);
  const navbarIconUrl = settings?.imageAssetUrls?.navbarIconUrl;
  const displayName = settings?.naming?.displayName;

  return (
    <HStack alignItems="center">
      {!!navbarIconUrl && (
        <Image
          source={{ uri: navbarIconUrl }}
          w={28}
          h={28}
          mr="$3"
          alt="Tenant Logo"
          resizeMode="contain"
        />
      )}
      <Text fontSize={15} fontWeight="semibold" color="$textBody">
        Lecturer
      </Text>
      {!!displayName && (
        <Text fontSize={14} color="$textSubtle" ml="$3">
          {displayName}
        </Text>
      )}
    </HStack>
  );
};

export default LecturerHeaderLeft;
